// DS1.7.5
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './ThumbStatusIndicator.scss';
const validCombinations = {
    'in-tier': [
        'large',
        'medium',
        'small'
    ],
    'premium-folder': [
        'large',
        'medium',
        'small'
    ],
    'watchers-only-folder': [
        'large',
        'medium'
    ],
    commission: [
        'large',
        'medium',
        'small'
    ],
    adoptable: [
        'large',
        'medium',
        'small'
    ],
    pcp: [
        'medium',
        'small'
    ],
    nft: [
        'medium'
    ]
};
const fileNameMap = {
    'in-tier': 'tier',
    'premium-folder': 'pg',
    'watchers-only-folder': 'watchers',
    pcp: 'pcp',
    adoptable: 'adopt',
    commission: 'commission'
};
const ThumbStatusIndicator = ({ type, size, className, hasAccess })=>{
    // not all combinations exist
    if (!validCombinations[type].includes(size)) {
        return null;
    }
    var _fileNameMap_type;
    let fileName = (_fileNameMap_type = fileNameMap[type]) !== null && _fileNameMap_type !== void 0 ? _fileNameMap_type : type;
    if (fileName === 'tier') {
        fileName = hasAccess ? 'tier' : 'locked';
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement("img", {
        alt: "",
        className: s['image'],
        src: Url.staticCDNLink(`eclipse/global/svg/deviation-status-icons/v2/${fileName}-${size}.svg?23`)
    }));
};
ThumbStatusIndicator.displayName = 'ThumbStatusIndicator';
export default ThumbStatusIndicator;

//# sourceMappingURL=ThumbStatusIndicator.js.map